import React, { useEffect, useState } from 'react';
import AdminNav from '../components/AdminNav';

const s = {
  page: { minHeight: '100vh', background: '#f8f8f6' },
  content: { maxWidth: '960px', margin: '0 auto', padding: '40px 16px' },
  heading: { fontSize: '22px', fontWeight: '700', color: '#111', marginBottom: '24px' },
  form: { background: '#fff', borderRadius: '10px', boxShadow: '0 1px 8px rgba(0,0,0,0.07)', padding: '24px', marginBottom: '32px' },
  formTitle: { fontSize: '15px', fontWeight: '700', color: '#111', marginBottom: '16px' },
  row: { display: 'flex', gap: '12px', flexWrap: 'wrap', marginBottom: '12px' },
  input: { flex: '1', minWidth: '160px', padding: '9px 12px', border: '1.5px solid #ddd', borderRadius: '7px', fontSize: '14px', outline: 'none' },
  select: { padding: '9px 12px', border: '1.5px solid #ddd', borderRadius: '7px', fontSize: '14px', background: '#fff' },
  btn: { padding: '10px 20px', background: '#111', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer' },
  err: { color: '#dc2626', fontSize: '13px', marginTop: '8px' },
  hint: { fontSize: '12px', color: '#888', marginTop: '4px' },
  table: { width: '100%', borderCollapse: 'collapse', background: '#fff', borderRadius: '10px', overflow: 'hidden', boxShadow: '0 1px 8px rgba(0,0,0,0.07)' },
  th: { padding: '12px 16px', textAlign: 'left', fontSize: '12px', fontWeight: '700', color: '#888', borderBottom: '1px solid #eee', background: '#fafafa', letterSpacing: '0.04em', textTransform: 'uppercase' },
  td: { padding: '12px 16px', fontSize: '14px', color: '#222', borderBottom: '1px solid #f0f0f0' },
  actionBtn: { padding: '5px 12px', borderRadius: '6px', border: 'none', fontSize: '12px', fontWeight: '600', cursor: 'pointer', marginRight: '6px' },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '16px' },
  modal: { background: '#fff', borderRadius: '12px', boxShadow: '0 8px 40px rgba(0,0,0,0.18)', width: '100%', maxWidth: '400px', padding: '28px' },
  modalTitle: { fontSize: '16px', fontWeight: '700', color: '#111', marginBottom: '16px' },
  modalInput: { width: '100%', padding: '9px 12px', border: '1.5px solid #ddd', borderRadius: '7px', fontSize: '14px', outline: 'none', marginBottom: '12px', boxSizing: 'border-box' },
  modalHint: { fontSize: '12px', color: '#888', marginTop: '-8px', marginBottom: '12px' },
  modalBtns: { display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '4px' },
  cancelBtn: { padding: '9px 18px', background: '#fff', color: '#444', border: '1.5px solid #ddd', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer' },
  confirmBtn: { padding: '9px 18px', background: '#111', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer' },
};

export default function UserManager() {
  const [users, setUsers] = useState([]);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('admin');
  const [error, setError] = useState('');
  const [creating, setCreating] = useState(false);
  const [modal, setModal] = useState(null); // { type: 'username'|'password', user }
  const [modalValue, setModalValue] = useState('');
  const [modalValue2, setModalValue2] = useState('');
  const [modalError, setModalError] = useState('');
  const [modalSaving, setModalSaving] = useState(false);
  const myUsername = localStorage.getItem('username');

  const fetchUsers = () => {
    fetch('/api/admin/users', { credentials: 'include' })
      .then((r) => r.json())
      .then((data) => setUsers(Array.isArray(data) ? data : []))
      .catch(console.error);
  };

  useEffect(fetchUsers, []); // eslint-disable-line

  const createUser = async (e) => {
    e.preventDefault();
    setError('');
    setCreating(true);
    try {
      const res = await fetch('/api/admin/users', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ username, password, role }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Failed to create user.'); return; }
      setUsername(''); setPassword(''); setRole('admin');
      fetchUsers();
    } catch {
      setError('Network error.');
    } finally {
      setCreating(false);
    }
  };

  const deleteUser = async (id) => {
    if (!window.confirm('Delete this user?')) return;
    try {
      const res = await fetch(`/api/admin/users/${id}`, { method: 'DELETE', credentials: 'include' });
      const data = await res.json();
      if (!res.ok) { alert(data.error || 'Delete failed.'); return; }
      fetchUsers();
    } catch {
      alert('Network error.');
    }
  };

  const openModal = (type, user) => {
    setModal({ type, user });
    setModalValue('');
    setModalValue2('');
    setModalError('');
  };

  const closeModal = () => setModal(null);

  const saveModal = async () => {
    setModalError('');
    if (modal.type === 'username') {
      if (!modalValue) { setModalError('Username is required.'); return; }
      setModalSaving(true);
      try {
        const res = await fetch(`/api/admin/users/${modal.user.id}/username`, {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ username: modalValue }),
        });
        const data = await res.json();
        if (!res.ok) { setModalError(data.error || 'Failed.'); return; }
        closeModal(); fetchUsers();
      } catch { setModalError('Network error.'); }
      finally { setModalSaving(false); }
    } else {
      if (!modalValue) { setModalError('Password is required.'); return; }
      if (modalValue !== modalValue2) { setModalError('Passwords do not match.'); return; }
      setModalSaving(true);
      try {
        const res = await fetch(`/api/admin/users/${modal.user.id}/reset-password`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ newPassword: modalValue }),
        });
        const data = await res.json();
        if (!res.ok) { setModalError(data.error || 'Failed.'); return; }
        closeModal();
      } catch { setModalError('Network error.'); }
      finally { setModalSaving(false); }
    }
  };

  const fmt = (d) => d ? new Date(d).toLocaleDateString() : '—';

  return (
    <div style={s.page}>
      <AdminNav />

      <div style={s.content}>
        <div style={s.heading}>User Manager</div>

        <div style={s.form}>
          <div style={s.formTitle}>Create New User</div>
          <form onSubmit={createUser}>
            <div style={s.row}>
              <input style={s.input} type="text" placeholder="Username" value={username} onChange={(e) => setUsername(e.target.value)} required autoComplete="off" />
              <input style={s.input} type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
              <select style={s.select} value={role} onChange={(e) => setRole(e.target.value)}>
                <option value="admin">admin</option>
                <option value="dev">dev</option>
              </select>
              <button type="submit" style={s.btn} disabled={creating}>{creating ? 'Creating…' : 'Create User'}</button>
            </div>
            <div style={s.hint}>Password: min 8 chars, must include uppercase, lowercase, and a number.</div>
            {error && <div style={s.err}>{error}</div>}
          </form>
        </div>

        <table style={s.table}>
          <thead>
            <tr>{['Username', 'Role', 'Created', 'Actions'].map((h) => <th key={h} style={s.th}>{h}</th>)}</tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id}>
                <td style={{ ...s.td, fontFamily: 'monospace' }}>{u.username}</td>
                <td style={s.td}>
                  <span style={{ padding: '2px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: '700', background: u.role === 'dev' ? '#fef9c3' : '#f0f9ff', color: u.role === 'dev' ? '#854d0e' : '#0369a1' }}>{u.role}</span>
                </td>
                <td style={s.td}>{fmt(u.createdAt)}</td>
                <td style={s.td}>
                  <button style={{ ...s.actionBtn, background: '#f0f9ff', color: '#0369a1' }} onClick={() => openModal('username', u)}>Change Username</button>
                  <button style={{ ...s.actionBtn, background: '#fef9c3', color: '#854d0e' }} onClick={() => openModal('password', u)}>Reset Password</button>
                  {u.username !== myUsername && (
                    <button style={{ ...s.actionBtn, background: '#fef2f2', color: '#dc2626' }} onClick={() => deleteUser(u.id)}>Delete</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modal && (
        <div style={s.overlay} onClick={closeModal}>
          <div style={s.modal} onClick={(e) => e.stopPropagation()}>
            <div style={s.modalTitle}>
              {modal.type === 'username' ? `Change Username — ${modal.user.username}` : `Reset Password — ${modal.user.username}`}
            </div>
            {modal.type === 'username' ? (
              <input style={s.modalInput} type="text" placeholder="New username" value={modalValue} onChange={(e) => setModalValue(e.target.value)} autoFocus autoComplete="off" />
            ) : (
              <>
                <input style={s.modalInput} type="password" placeholder="New password" value={modalValue} onChange={(e) => setModalValue(e.target.value)} autoFocus />
                <input style={s.modalInput} type="password" placeholder="Confirm new password" value={modalValue2} onChange={(e) => setModalValue2(e.target.value)} />
                <div style={s.modalHint}>Min 8 chars, must include uppercase, lowercase, and a number.</div>
              </>
            )}
            {modalError && <div style={{ ...s.err, marginBottom: '10px' }}>{modalError}</div>}
            <div style={s.modalBtns}>
              <button style={s.cancelBtn} onClick={closeModal}>Cancel</button>
              <button style={s.confirmBtn} onClick={saveModal} disabled={modalSaving}>{modalSaving ? 'Saving…' : 'Save'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
